<template>
  <div>
    <PageHeaderLayout>
      <el-button style="margin-bottom: 10px;" @click="goBack()" icon="el-icon-back" size="medium">
        返回
      </el-button>
      <div class="main-page-content" style="margin-top: 20px;">
        <el-row>
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="公司名称">
              <el-input v-model="searchCondition.company_name" placeholder="输入公司名称" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="企业类型">
              <el-select v-model="searchCondition.status" filterable clearable placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="负责人手机号">
              <el-input v-model="searchCondition.contact_phone" placeholder="输入负责人手机号" clearable></el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-tabs v-model="corp_type" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name"
            class="tab-item">
          </el-tab-pane>
        </el-tabs>
        <ApeTable v-permission:issue_list ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus"
          :pagingData="pagingData" highlight-current-row @switchPaging="switchPaging">
          <el-table-column align="center" label="套餐包余量">
            <template slot-scope="scope">
              <el-link type="primary" @click="showSurplus(scope.row)">查看
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="扣费设定">
            <template slot-scope="scope">
              <el-link type="primary" @click="updateSetting(scope.row)">设置
              </el-link>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="操作">
            <template slot-scope="scope">
              <!-- v-permission:issue_configure -->
              <div v-if="scope.row.status==2">
                已解绑
              </div>
              <el-button v-else size="mini" type="text" @click="unbinding(scope.row.company_id,scope.row.company_type,1)">解绑</el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <!-- 扣费设定 -->
    <el-dialog :visible.sync="isShowSetting" destroy-on-close width="50%" title="设置" :before-close='beforeClose'>
      <el-form ref="form" label-width="180px">
        <el-form-item required :label="item.lable" v-for="(item,index) in setting.fromData" :key="index">
          <el-input v-model.trim="setting.fromData[index].val" type="text"><template #append>
              {{item.append|| '元/条'}}
            </template></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="settingSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 查看余量 -->
    <el-dialog :visible.sync="isShowSurplus" destroy-on-close width="50%" title="套餐包余量" :before-close='beforeSurplusClose'>
      <el-form ref="form" label-width="180px">
        <el-form-item :label="item.lable" v-for="(item,index) in surplusSetting.fromData" :key="index">
          <el-input disabled v-model.trim="surplusSetting.fromData[index].val" type="text"><template #append>
              {{item.append|| '条'}}
            </template></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="surplusSettingSubmit">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import PageHeaderLayout from "@/layouts/PageHeaderLayout";
  import ModalDialog from '@/components/ModalDialog'
  import UploadFile from "@/components/UploadFile";
  import ApeTable from "@/components/ApeTable";
  import tzForm from "@/components/tz-form";
  import DatePicker from '@/components/DatePicker.vue';
  import reg from '@/utils/reg.js'
  import {
    mapGetters
  } from 'vuex'
  export default {
    components: {
      tzForm,
      PageHeaderLayout,
      ApeTable,
      ModalDialog,
      UploadFile,
      DatePicker
    },
    data() {
      return {
        tabsList: [{
            label: "人资公司",
            name: "1",
          },
          {
            label: "用工企业",
            name: "2",
          },
        ],
        corp_type: "1",
        not_select: false,
        type: 0,
        id: '',
        formButtonArr: [{
          label: '确定',
          type: 'primary',
          flag: 'add'
        }],
        is_show_form: false,
        loadingStaus: false,
        typeList: [{
            name: '人资公司',
            id: '1'
          },
          {
            name: '用工企业',
            id: '2'
          },
        ],
        // 分页信息
        pagingData: {
          is_show: true,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0
        },
        dataList: [],
        columns: [{
            title: "公司名称",
            value: "company_name",
            header_align: "center",
            align: "center",
          },
          {
            title: "累计充值金额",
            value: "recharge_money",
            header_align: "center",
            align: "center",
          },
          {
            title: "可用余额",
            value: "balance_money",
            header_align: "center",
            align: "center",
          },
          {
            title: "所得收益",
            value: "operator_profit",
            header_align: "center",
            align: "center",
          },
        ],
        searchCondition: {
          company_name: '',
          status: '',
          contact_phone: ''
        },
        isShowSetting: false,
        isShowSurplus: false,
        surplusSetting: {
          fromData: [{
              lable: '短信认证签约：',
              val: '',
              filed: 'esignsms_num'
            },
            {
              lable: '人脸识别认证签约：',
              val: '',
              filed: 'esignface_num'
            },
            {
              lable: '银行卡四要素认证签约：',
              val: '',
              filed: 'esignbank_num'
            },
            {
              lable: '智能算税：',
              val: '',
              filed: 'tax_num'
            },
            {
              lable: '短信通知类：',
              val: '',
              filed: 'sms_num',
              append: '条'
            },
            {
              lable: '自定义电子合同：',
              val: '',
              filed: 'cont_num',
              append: "份",
            },
            {
              lable: '管理员角色：',
              val: '',
              filed: 'adm_num'
            },
            {
              lable: '人才库：',
              val: '',
              filed: 'surplus_num',
              append: '人'
            }
          ]
        },
        setting: {
          fromData: [{
              lable: '短信认证签约：',
              val: '',
              filed: 'esignsms_money'
            },
            {
              lable: '人脸识别认证签约：',
              val: '',
              filed: 'esignface_money'
            },
            {
              lable: '银行卡四要素认证签约：',
              val: '',
              filed: 'esignbank_money'
            },
            {
              lable: '智能算税：',
              val: '',
              filed: 'tax_money'
            },
            {
              lable: '短信通知类：',
              val: '',
              filed: 'sms_money',
              append: '元/条'
            },
            {
              lable: '自定义电子合同：',
              val: '',
              filed: 'cont_money',
              append: "元/份",
            },
            {
              lable: '管理员角色：',
              val: '',
              filed: 'adm_money'
            },
            {
              lable: '人才库：',
              val: '',
              filed: 'pool_money',
              append: '元/人/年'
            },
            {
              lable: '人才库免费人数：',
              val: '',
              filed: 'free_pool_number',
              append: "人",
            },
          ]
        },
      };
    },
    watch: {},
    methods: {
      beforeClose(done) {
        //关闭清空表单值
        this.setting.fromData.map((item) => {
          item.val = ''
        })
        done && done()
      },
      beforeSurplusClose(done) {
        //关闭清空表单值
        this.surplusSetting.fromData.map((item) => {
          item.val = ''
        })
        done && done()
      },
      //点击tab切换
      async handleClick(tab) {
        this.corp_type = tab.name;
        this.init();
      },
      async settingSubmit() {
        //校验格式
        for (let item of this.setting.fromData) {

          if (!reg?.money.test(item.val)) {
            return this.$message.error(item.lable + '金额格式不正确')
          }
        }

        //获取表单的值
        let fromData = {}
        for (let item of this.setting.fromData) {
          fromData[item.filed] = item.val
        }
        //请求
        let res = await this.$api.postSettingRecharge({
          company_id: this.id,
          company_type: this.corp_type,
          ...fromData
        })
        if (res) {
          this.isShowSetting = false
          this.init()
        }

      },
      
      surplusSettingSubmit(){
        this.isShowSurplus = false
      },
      //查询单次费用
      async getRechageSetRecord() {
        let res = await this.$api.postOneRechargeRecord({
          company_id: this.id,
          company_type: this.corp_type,
        })
        this.info_money = res
        this.setting.fromData.map((item) => {
          item.val = res[item.filed] || ''
          return item
        })

        console.log(this.setting.fromData)
      },
      async updateSetting(row) {
        this.id = row.company_id
        this.isShowSetting = true
        this.getRechageSetRecord()
      },
      async showSurplus(row) {
        this.id = row.company_id
        this.isShowSurplus = true
        this.getSurPlusNum()
      },
      //查询单次费用
      async getSurPlusNum() {
        let res = await this.$api.getSurPlusNum({
          company_id: this.id,
          company_type: this.corp_type,
          operator_company_id:this.supplier_id
        })
        this.surplusSetting.fromData.map((item) => {
          item.val = res[item.filed] || 0
          return item
        })
      
      },
      unbinding(arg,type, val) {
        this.$confirm('点击“确认”后，该公司将被解绑，请仔细确认后在操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbindingFun(arg,type, val)
        }).catch(() => {

        })
      },
      // 取消资格
      async unbindingFun(id,company_type) {
        let data = {
          company_id:id,
          company_type:company_type,
          supplier_id:this.supplier_id
        }
        var res = await this.$api.deleteSupplierCustomerInfo(data)
        this.$nextTick(() => {
          if (res) {
            this.$message.success('解绑成功!')
            this.init()
          }
        })
      
      },
      //返回上一页
      goBack() {
        this.$router.push({
          path: "/operator_package"
        });
      },
      // 重置分页
      async resetPage() {
        this.$refs.apeTable.currentPage = 1
      },
      // 切换页码操作
      async switchPaging() {
        this.init();
      },
      // 搜索
      searchButton() {
        this.resetPage()
        this.init('search')
      },
      //获取列表
      async init(type) {
        if(!this.supplier_id) return;
        this.loadingStaus = true
        let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
        let searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, pagingInfo,{
          company_type:this.corp_type,
          supplier_id:this.supplier_id
        })
        this.dataList = []
        let {
          data,
          pages
        } = await this.$api.getPackageOperatorCompanyList(searchCondition)
        this.$nextTick(() => {
          this.dataList = data
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus = false
      },
      // 处理搜索条件
      handleSearchCondition() {
        let condition = {}
        if (this.searchCondition.company_name) {
          condition.company_name = this.searchCondition.company_name
        }

        if (this.searchCondition.status) {
          condition.status = this.searchCondition.status
        }

        if (this.searchCondition.contact_phone) {
          condition.contact_phone = this.searchCondition.contact_phone
        }

        return condition
      }
    },
    computed: {
      ...mapGetters(['userPermissions'])
    },
    mounted() {
      this.resetPage()
      this.supplier_id = this.$route.query.id;
      this.init();
    },
  };
</script>

<style lang="scss" scoped>

</style>
